import { Checkbox } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import { MdmCardFormStore } from "../MdmCardFormStore";
import { FormField } from "../types/MdmCardFormTypes";
import { FieldBox } from "./FieldBox";

interface PropsCardCheckbox {
  form: MdmCardFormStore;
  field: FormField;
}

export const CardCheckbox: React.FC<PropsCardCheckbox> = observer((props) => {
  const { form, field } = props;
  const { data, path } = field;
  const fieldValue: boolean = data?.type === "bool" ? data.value : false;

  const cbField = {
    ...field,
    meta: {
      ...field.meta,
      title: null,
    },
  };
  return (
    <FieldBox field={cbField} form={form}>
      <Checkbox
        disabled={form.isItemDisabled(field)}
        checked={fieldValue}
        onChange={(e) => {
          const { checked } = e.target;
          field.setData({
            type: "bool",
            value: checked,
            name: field.meta.name,
          });
          form.onChange(path);
        }}
      >
        {field.meta.title}
      </Checkbox>
    </FieldBox>
  );
});
